<div [formGroup]="ClientForm">
    <upp-form-section title="{{tr('@place_client_title')}}">
        <ion-item>
            <upp-input uppDataid="clientedit-name-text"
                formControlName="merchantName"
                type="text"
                [readonly]="readonly"
                placeholder="{{tr('@place_client_input_name_ph')}}"
                title="{{tr('@place_client_input_name')}}"
                (Changed)="AutocompleteOptions('merchantName')"
                [errornfo]="{ required: tr('@mandatory_field') }">
            </upp-input>
        </ion-item>
        <div class="dropdown" *ngIf="!readonly" [ngClass]="{ 'visible': Autocomplete('merchantName') }">
            <ion-list>
                <ion-item uppDataid="clientedit-business-info"
                    *ngFor="let _client of BusinessOptions"
                    lines="none"
                    (click)="OnSelect(_client)">
                    <ion-label>{{_client.name}} ({{_client.taxid}})</ion-label>
                </ion-item>
            </ion-list>
        </div>
        <ion-item>
            <upp-input uppDataid="clientedit-taxid-text"
                formControlName="merchantTaxid"
                type="text"
                [readonly]="readonly"
                placeholder="{{tr('@place_client_input_taxid_ph')}}"
                title="{{tr('@place_client_input_taxid')}}"
                (Changed)="AutocompleteOptions('merchantTaxid')"
                [errornfo]="{ required: tr('@mandatory_field') }">
            </upp-input>
        </ion-item>
        <div class="dropdown" *ngIf="!readonly" [ngClass]="{ 'visible': Autocomplete('merchantTaxid') }">
            <ion-list>
                <ion-item uppDataid="clientedit-business-info"
                    *ngFor="let _client of BusinessOptions"
                    lines="none"
                    (click)="OnSelect(_client)">
                    <ion-label>{{_client.name}} ({{_client.taxid}})</ion-label>
                </ion-item>
            </ion-list>
        </div>
        <upp-form-warning
            *ngIf="TaxIdUnverified"
            class="taxid-warning"
            uppDataid="clientedit-foreign-taxid-warning"
            color="warning"
            icon="earth-outline"
            title="{{tr('@place_client_foreign_taxid_title')}}"
            subtitle="{{tr('@place_client_foreign_taxid_message')}}"
        ></upp-form-warning>
        <ion-item>
            <upp-input uppDataid="clientedit-email-text"
                formControlName="merchantEmail"
                type="text"
                [readonly]="readonly"
                placeholder="{{tr('@place_client_input_email_ph')}}"
                title="{{tr('@place_client_input_email')}}"
                (Changed)="OnValueChanged()"
                [errornfo]="{ email: tr('@enter_valid_email') }">
            </upp-input>
        </ion-item>
        <ion-item (focusout)="OnAddressBlur()">
            <upp-input uppDataid="clientedit-address-text"
                formControlName="merchantAddress"
                type="text"
                [readonly]="readonly"
                placeholder="{{tr('@place_client_input_address_ph')}}"
                title="{{tr('@place_client_input_address')}}"
                (Changed)="OnValueChanged()">
            </upp-input>
        </ion-item>
        <ng-container *ngIf="!IsSpain && Country">
            <upp-form-warning uppDataid="clientedit-address-warning" class="address-warning"
                *ngIf="!ValidAddress"
                color="warning"
                icon="location-outline"
                title="{{tr('@place_client_address_geocode_error')}}"
            ></upp-form-warning>
            <ion-item *ngIf="ValidAddress">
                <upp-input uppDataid="clientedit-country-text"
                    [value]="Country"
                    type="text"
                    [readonly]="true"
                    placeholder="{{tr('@place_client_input_country_ph')}}"
                    title="{{tr('@place_client_input_country')}}">
                </upp-input>
            </ion-item>
        </ng-container>
        <ion-grid *ngIf="IsSpain || !Country" class="address-grid">
            <ion-row>
                <ion-col size="4">
                    <ion-item>
                        <upp-input uppDataid="clientedit-postalcode-text"
                            formControlName="merchantPostal"
                            type="text"
                            [readonly]="readonly"
                            placeholder="{{tr('@place_client_input_zipcode_ph')}}"
                            title="{{tr('@place_client_input_zipcode')}}"
                            (Changed)="OnValueChanged()"
                            [errornfo]="{ required: tr('@mandatory_field') }">
                        </upp-input>
                    </ion-item>
                </ion-col>
                <ion-col size="8">
                    <ion-item>
                        <upp-input uppDataid="clientedit-region-text"
                            formControlName="merchantRegion"
                            type="text"
                            [readonly]="readonly"
                            placeholder="{{tr('@place_client_input_region_ph')}}"
                            title="{{tr('@place_client_input_region')}}"
                            (Changed)="OnValueChanged()"
                            [errornfo]="{ required: tr('@mandatory_field') }">
                        </upp-input>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </upp-form-section>

    <upp-form-section *ngIf="!readonly && lookup"
        title="{{tr('@place_client_list_title')}}"
        [fill]="Clients.length === 0 ? 'clear' : 'solid'">
        <upp-form-warning uppDataid="clientedit-empty-warning"
            *ngIf="Clients.length === 0"
            color="danger"
            icon="alert-circle-outline"
            title="{{tr('@place_client_list_empty_title')}}"
            subtitle="{{tr('@place_client_list_empty_message')}}"
        ></upp-form-warning>
        <upp-client-thumb
            *ngFor="let _client of Clients"
            [client]="_client"
            [isPayAccount]="IsPayAccount(_client)"
            (Select)="OnSelect($event)"
        ></upp-client-thumb>
    </upp-form-section>
</div>
